export default __webpack_public_path__ + "static/media/photograph.d0d7c1a3.svg";